<template>
  <div>
    <button color="purple" class="support-btn" id="support-btn" @click="dialog=true">
      <i class="material-icons support-icon">
        help
      </i>
    </button>
    <modal v-if="dialog" title="Having a problem?" @submit="submit" btn="Submit" @close="dialog=false">
        <div>
          <div class="" v-if="!id">
            <h-input label="Name" v-model="name" outline required/>
            <h-input label="Email" v-model="email" outline type="email" required/>
            </div>
          <div class="input">
            <label>Please describe the problem</label>
            <textarea
              outline
              v-model="problem"
            />
          </div>
        </div>
    </modal>
  </div>
</template>

<script>
import { adapter } from "@/services/api/store";
import modal from "@/components/modal/default";
import snackbarHub from "@/services/hubs/snackbar";
import User from "@/services/api/authUser";

let http = adapter.http;
export default {
  components: { modal },
  props: ["id"],
  data() {
    return {
      dialog: false,
      problem: "",
      name: "",
      email: "",
      User: User
    };
  },
  methods: {
    clear() {
      this.problem = "";
      this.dialog = false;
      this.name = "";
      this.email = "";
    },
    submit() {
      http
        .post(`${process.env.VUE_APP_API_URL}support/`, {
          message: this.problem,
          version: `${process.env.VUE_APP_VERSION}`,
          name: this.name,
          email: this.email,
          url: window.location.href
        })
        .then(() => {
          snackbarHub.update("Our staff has been notified!");
          this.clear();
        });
    }
  }
};
</script>

<style>
.support-btn {
  position: fixed;
  bottom: 20px;
  right: 20px;
}
.support-icon {
  color: white;
  background-color: purple;
  border-radius: 50%;
  padding: 15px;
}
</style>
